module.exports = __webpack_public_path__ + "media/greeting_general.6a589a9d.mp4";